/**
 * @Author: Nenad Brcic
 * @Date: 02.10.16
 * @Email: neno@neno.ch
 */

import React, { PropTypes } from 'react';

const RelSectionTemplate = ({ title, children, listItems }) => (
    <section >
        <h2 className="list-section-title">
                <span className="list-section-title-inner">
                    { title }
                </span>
        </h2>
        { children }
        <ul className="object-list">
            { listItems }
        </ul>
    </section>
);

RelSectionTemplate.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.object,
    listItems: PropTypes.array,
};

export default RelSectionTemplate;


// WEBPACK FOOTER //
// ./app/components/shared/RelSectionTemplate/index.jsx